import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { Web3Service } from '@/services/web3.service';

@Component({
  selector: 'app-approval-modal',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div 
      class="modal-overlay"
      [class.active]="modalActive"
      [class]="modalActive ? 'modal' : ''">
      
      <div class="modal">
        <div class="punk-info">
          <h2>Approval Required</h2>
          <p>
            You have listed tokens on the marketplace but it appears that our contract is not authorized 
            to transfer the token to potential buyers. Please validate the approval transaction.
          </p>
        </div>
        
        <div class="form-actions">
          <button class="cancel" (click)="cancel()">Cancel</button>
          <button class="submit" (click)="confirm()">Validate</button>
        </div>

        <p>By interacting with this App, you agree to our <a href="/assets/tos.pdf" target="_blank">Terms of Use</a></p>
      </div>
    </div>
  `,
  styleUrls: ['./approval-modal.component.scss']
})
export class ApprovalModalComponent implements OnInit, OnDestroy {
  modalActive: boolean = false;
  private subscription = new Subscription();

  constructor(private web3Service: Web3Service) {}

  ngOnInit(): void {
    this.subscription.add(
      this.web3Service.approvalModalActive$.subscribe(active => {
        this.modalActive = active;
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  async confirm(): Promise<void> {
    await this.web3Service.confirmApproval();
  }

  cancel(): void {
    this.web3Service.hideApprovalModal();
  }
} 